/**
 * @file Form Page
 */

import vExternalForm from '../../components/embedded-form/embedded-form';

/**
 * Form Page functions
 *
 * Runs js specific to the Form Page template
 */
const vFormPage = () => {
	vExternalForm();
};

if (document.readyState !== 'loading') {
	vFormPage();
} else {
	document.addEventListener('DOMContentLoaded', vFormPage);
}
